import * as React from "react";
import { cn } from "@/lib/cn";

const variants = {
  default: "bg-beijer/10 text-beijer-dark",
  license: "bg-accent-orange/15 text-accent-orange border-accent-orange/30",
  wholesale: "bg-beijer/15 text-beijer border-beijer/40",
  general: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30",
  net: "bg-beijer-dark/10 text-beijer-dark border-beijer-dark/30",
} as const;

export function Badge({
  className,
  variant = "default",
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { variant?: keyof typeof variants }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide",
        variants[variant],
        className,
      )}
      {...props}
    />
  );
}
